import { ethers } from 'ethers';
import { useCallback, useEffect, useRef } from 'react';
import { credentialsFromSignerContext, useCredentialStore } from '../store/use-credential-store';
import { useTownsContext } from '../components/TownsContextProvider';
import { useCasablancaStore } from '../store/use-casablanca-store';
import { AuthStatus } from './login';
import { SignerUndefinedError } from '../types/error-types';
import { makeSignerContext } from '@towns-protocol/sdk';
export function useCasablancaWalletSignIn() {
    const { environmentId } = useTownsContext();
    const { setCasablancaCredentials } = useCredentialStore();
    const { setAuthError, setAuthStatus } = useCasablancaStore();
    const isMounted = useRef(true);
    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);
    const getIsWalletRegisteredWithCasablanca = useCallback(async () => {
        // currently we don't need to register? you can just login with your wallet
        return Promise.resolve(true);
    }, []);
    const loginWithWalletToCasablanca = useCallback(async (_statement, signer, { onSuccess, onError } = {}) => {
        if (!signer) {
            throw new SignerUndefinedError();
        }
        if (!environmentId) {
            throw new Error('environmentId not set');
        }
        const delegateWallet = ethers.Wallet.createRandom();
        const wallet = (await signer.getAddress());
        try {
            const casablancaContext = await makeSignerContext(signer, delegateWallet);
            if (isMounted.current) {
                setCasablancaCredentials(environmentId, credentialsFromSignerContext(wallet, delegateWallet, casablancaContext));
                onSuccess?.({
                    wallet,
                    delegateWallet: delegateWallet,
                    casablancaContext,
                });
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }
        catch (e) {
            if (isMounted.current) {
                console.error('loginWithWalletToCasablanca error', e);
                setAuthError({
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                    code: e?.code ?? 0,
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/restrict-template-expressions
                    message: e?.message ?? `${e}`,
                    error: e,
                });
                setAuthStatus(AuthStatus.None);
                onError?.(e);
            }
        }
    }, [environmentId, setAuthError, setAuthStatus, setCasablancaCredentials]);
    const registerWalletWithCasablanca = useCallback(async (statement, signer) => {
        // currently we don't need to register? you can just login with your wallet
        return loginWithWalletToCasablanca(statement, signer);
    }, [loginWithWalletToCasablanca]);
    return {
        getIsWalletRegisteredWithCasablanca,
        loginWithWalletToCasablanca,
        registerWalletWithCasablanca,
    };
}
//# sourceMappingURL=use-casablanca-wallet-signin.js.map